import React from 'react'
import sidebarService from '../Service/menuService'
// import Cari_Obat from '../CariObat/modalSearch'
import { config } from '../Config/config'
import Cari_Doctor from '../Doctor/index'

export default class Sidebar extends React.Component {

    constructor() {
        super()
        this.state = {
            List: [],
            ListSub: [],
            ListM: [],
            ListT: [],
            showModalCari: false,
            showModalDoctor: false
        }
    }

    showModalDoctor =()=>{
        this.setState({
            showModalDoctor:true
        })
    }

    showModal = () => {
        this.setState({
            showModalCari: true
        })
    }

    cancelModal = () => {
        this.setState({
            showModalCari: false,
            showModalDoctor: false
        })
    }


    loadList = async () => {
        const respon = await sidebarService.getByCode(localStorage.getItem(config.role))
        const responSub = await sidebarService.getSubByCode(localStorage.getItem(config.role))
        const responM = await sidebarService.getByCodeM(localStorage.getItem(config.role))
        const responT = await sidebarService.getByCodeT(localStorage.getItem(config.role))
        if (responM.success) {
            this.setState({
                List: respon.result,
                ListSub: responM.result,
                ListM: responM.result,
                ListT: responT.result
            })
        }

    }

    componentDidMount() {
        this.loadList()
        console.log(localStorage.getItem(config.role))
    }


    render() {
        const { ListM, ListT, List, ListSub } = this.state
        return (
            <div>

                <div class="sidebar" id="sidebar">
                    <div class="slimScrollDiv" ><div class="sidebar-inner slimscroll" >
                        <div id="sidebar-menu" class="sidebar-menu">
                            <ul>

                                <li class="submenu">
            
                                </li>
                                <li class="submenu">
                                    {
                                        List.map(data => {
                                            var subMenu = ListSub
                                            return (

                                                <a href={data.url}><img class="img-fluid mr-1" src={data.small_icon} width="20" alt="Admin" /><span>{data.nama}</span></a>

                                            )
                                        })
                                                                            
                                    }
                                    {
                                        ListSub.map(data => {
                                            return (
                                                <ul style={{display: "none"}}>
                                                <li><a href={data.url}><img class="img-fluid mr-1" src={data.small_icon} width="20" alt="Admin" /><span>{data.nama}</span></a></li>
                                            </ul>
                                            )

                                        })
                                    }

                                    {localStorage.getItem(config.role) == "ROLE_PASIEN" ?
                                        <>
                                            <a href="javascript:void(0)" onClick={this.showModal}><img class="img-fluid mr-1" src="assets/img/icon/search_black_48dp.svg" width="20" alt="Admin" /><span>Cari Obat</span></a>
                                            <a href="javascript:void(0)" onClick={this.showModalDoctor}><img class="img-fluid mr-1" src="assets/img/icon/search_black_48dp.svg" width="20" alt="Admin" /><span>Cari Doctor</span></a>
                                        </>
                                        :
                                        <>
                                        </>
                                    }
                                </li>
                            </ul>


                        </div>
                    </div><div class="slimScrollBar" ></div><div class="slimScrollRail" ></div></div>
                </div>
                {/* <Cari_Obat
                    showModalCari={this.state.showModalCari}
                    cancelModal={this.cancelModal}
                /> */}
                <Cari_Doctor
                showModalDoctor={this.state.showModalDoctor}
                cancelModal={this.cancelModal}
                />
            </div>
        )
    }
}